<!-- scheduler 模板列表 -->
<template>
  <div class="SchedulerTemplateList">
    <!-- 项目模板 -->
    <div class="SchedulerTemplateTop">
      <div class="searchTitle">
        <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.search') }}</div>
            </div>
            <i
            class="iconfont icon-search pointer"
            @click="searchShow"
            ></i>
        </el-tooltip>
        <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.DefaultTemplateSchedule') }}</div>
            </div>
            <i
              v-if="IsLoopTemplate"
              class="iconfont icon-danquxunhuan"
              :class="{'HaveLoop': LoopTemplate.id}"
              @click="OpenLoopTemplate"
              :disabled="CloneDisabled.disableButton"
            >
          </i>
        </el-tooltip>
        <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.importASchedule') }}</div>
            </div>
            <i
            :disabled="CloneDisabled.disableButton"
            class="iconfont icon-export"
            @click="importSchedule"
            ></i>
        </el-tooltip>
        <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.addSchedule') }}</div>
            </div>
            <i
            :disabled="CloneDisabled.disableButton"
            class="iconfont icon-add pointer"
            @click="addSchedule"
            ></i>
        </el-tooltip>
      </div>
      <!-- 搜索框 -->
      <div
        class="searchInput"
        v-if="fileInput">
        <el-input
          ref="ResourceSearch"
          v-model="STemplateListParam.condition"
          :placeholder="$t('lang.fileName')"
          @keyup.enter.native="getSchedulerList(false)"></el-input>
        <i
          class="iconfont icon-search pointer"
          @click="getSchedulerList(false)"></i>
      </div>
    </div>
    <div
      class="STemplateListWrap"
      v-scroll="bindSTemplateScroll"  v-loading='SchedulerTemplateLoading'>
      <ul class="draggable_box STemplateItem">
        <li
          :class="['draggable_item', 'TemplateFile', {'pitchOnItem': PitchTemplate == item.id}, {'LoopTemplateName': LoopTemplate.id == item.id}]"
          @click="getCheck(item)"
          v-for="(item, index) in SchedulerTemplateList"
          :key="index"
          draggable="true"
          :data-target="'source' + index"
          :data-template="'ScheduleTemplates'"
          :data-device="JSON.stringify(item)">
          <div :class="['templateName', {'errTemplateName': item.completeSource}]"> {{ item.name ? item.name :item.createTime }}</div>
          <div class="icon">
            <i class="iconfont icon-refresh" v-if="item.completeSource" @click.stop="ClickSyncSource(item)" :title="$t('lang.ClickTitle')"></i>
            <i
              class="el-icon-edit-outline"
              :disabled="CloneDisabled.disableButton"
              @click.stop="editTemplateList(item)"></i>
            <i
              v-if="!(LoopTemplate.id == item.id)"
              :disabled="CloneDisabled.disableButton"
              class="el-icon-delete"
              @click="deleteTemplateList(item)"></i>
          </div>
        </li>
      </ul>
    </div>
    <!-- 创建模板 -->
    <create-schedule
      v-if="scheduleVisible"
      :scheduleVis="scheduleVisible"
      @visible="visibleParams"
    ></create-schedule>
    <!-- 循环模板 -->
    <LoopSchedulerTemplate v-if="LoopTemplate.switch" :LoopTemplate="LoopTemplate" @LoopTemplateUpdate="getRecurTemplate"></LoopSchedulerTemplate>
    <!-- 上传模板 -->
    <div class="ImportScheduler">
      <el-dialog
        :title="$t('lang.upLoadSchedule')"
        :visible.sync="ImportSwitch"
        width="600px">
        <ImportTemplate v-if="ImportSwitch" :awsInfo="awsInfo"></ImportTemplate>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import createSchedule from '@/views/Playout/createSchedule.vue'
import toTips from '@/assets/js/toTipsObj'
import { componentsAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import ImportTemplate from '@/components/common/ImportTemplate.vue'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import LoopSchedulerTemplate from '@/views/PlayoutPlus/common/LoopSchedulerTemplate.vue'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      // 模板文件搜素
      fileInput: false,
      // 模板列表
      SchedulerTemplateList: [],
      // 选中模板
      PitchTemplate: '',
      // STemplate绑定滚动事件
      bindSTemplateScroll: {
        onScroll: this.bindSTemplateScrollHandle,
        distance: 10,
        directive: '.STemplateItem'
      },
      // template是否有下一页
      STemplateHasnextpage: false,
      // template分页查询信息
      STemplateListParam: {
        pageNum: 1,
        pageSize: 20,
        condition: '',
        spliceType: '',
        startTime: '',
        endTime: ''
      },
      // 新增模板开关
      scheduleVisible: false,
      // 上传模板开关
      ImportSwitch: false,
      // aws信息
      awsInfo: {},
      // 是否循环
      IsLoopTemplate: false,
      // 循环模板
      LoopTemplate: {
        switch: false,
        id: '',
        name: '',
        scheduleType: '1',
        recurStartTime: null,
        recurEndTime: null,
        TimeType: 0
      },
      SchedulerTemplateLoading: false
    }
  },
  components: {
    createSchedule,
    ImportTemplate,
    LoopSchedulerTemplate
  },
  computed: {
    ...mapState({
      State: (state) => state,
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {
    this.awsInfo = this.$BehaviorSyns.getRegionBucket()
  },
  watch: {
    ImportSwitch (value) {
      if (!value) {
        this.getSchedulerList(false)
      }
    }
  },
  mounted () {
    this.getSchedulerList(false)
    Bus.$on('ScheduleTemplateUpdate', (data) => {
      this.getSchedulerList(false)
      // if (data) {
      //   this.PitchTemplate = data.id
      // }
    })
    this.getIsLoop()
    this.getRecurTemplate()
  },
  methods: {
    // 搜索模板
    searchShow () {
      componentsAnalyze('scheduleTemplateListSearchShow', '/ponent')
      this.fileInput = !this.fileInput
      this.STemplateListParam.condition = ''
      if (!this.fileInput) {
        this.getSchedulerList(false)
      } else {
        this.$nextTick(() => {
          this.$refs.ResourceSearch.focus()
        })
      }
    },
    // 获取是否设置循环模板
    getRecurTemplate () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/template/defaultRecurTemplate',
          {
            programId
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.LoopTemplate.id = result.id
            this.LoopTemplate.name = result.name
            this.LoopTemplate.scheduleType = result.scheduleType
            this.LoopTemplate.recurStartTime = result.recurStartTime
            this.LoopTemplate.recurEndTime = result.recurEndTime
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 获取是否设置循环模板
    getIsLoop () {
      const programId = this.$BehaviorSyns.getProgramId()
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/advance-setting/templates',
          {
            programId
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            const result = res.data.result
            this.IsLoopTemplate = result.enableRecurTemplate
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 打开循环模板
    OpenLoopTemplate () {
      if (this.CloneDisabled.disableButton) return
      this.LoopTemplate.switch = true
    },
    // 点击同步source
    ClickSyncSource (item) {
      const programId = this.$BehaviorSyns.getProgramId()
      const data = {
        templateId: item.id,
        userId: localStorage.getItem('userId'),
        programId
      }
      const formData = new FormData()
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
      })
      this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/template/refresh', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.getSchedulerList(false)
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 上传模板
    importSchedule () {
      if (this.CloneDisabled.disableButton) return
      this.ImportSwitch = true
    },
    // 编辑模板
    editTemplateList (item) {
      if (this.CloneDisabled.disableButton) return
      componentsAnalyze('scheduleTemplateListEditTemplateList', '/ponent')
      this.PitchTemplate = item.id
      NotManyEdit.checkUserEdit({ type: 2, logicId: item.id }).then((res) => {
        if (res) {
          if (item.type == '1') {
            this.$emit('editTemplate', {
              status: true,
              name: 'scheduleVis',
              data: item
            })
          } else {
            this.$emit('editTemplate', {
              status: true,
              name: 'formatVis',
              data: item
            })
          }
        }
      })
    },
    // 删除模板
    deleteTemplateList (data) {
      if (this.CloneDisabled.disableButton) return
      this.$confirm(this.$t('lang.deleteTemplate'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      })
        .then(() => {
          componentsAnalyze('scheduleTemplateListDeleteTemplateList', '/ponent')
          this.axios
            .post('/gatewayPlayoutUrl/tvu-playout/template/edit', {
              deleteFlag: '1',
              id: data.id
            })
            .then((res) => {
              if (res.status == 200) {
                if (res.data.errorCode == '0x0') {
                  this.getSchedulerList(false)
                  this.$message({
                    type: 'success',
                    message: this.$t('lang.success')
                  })
                  Bus.$emit('closeTemplate', data.id)
                } else {
                  const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
                  this.$message.info(errorInfo)
                }
              }
            }).catch(() => {})
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        })
    },
    // 新增模板成功
    visibleParams (data) {
      this.scheduleVisible = false
      this.getSchedulerList(false)
      if (data.status) {
        this.editTemplateList(data)
        this.getCheck(data)
      }
    },
    // 新增模板
    addSchedule (data) {
      if (this.CloneDisabled.disableButton) return
      componentsAnalyze('scheduleTemplateListAddSchedule', '/ponent')
      this.scheduleVisible = true
    },
    // 点击列表发生事情
    getCheck (data) {
      componentsAnalyze('scheduleTemplateListGetCheck', '/ponent')
      if (this.PitchTemplate == data.id) {
        this.PitchTemplate = ''
      } else {
        this.PitchTemplate = data.id
      }
    },
    // STemplate绑定滚动加载
    bindSTemplateScrollHandle () {
      if (this.STemplateHasnextpage) {
        this.STemplateListParam.pageNum++
        this.getSchedulerList(true)
      }
    },
    // 获取paogram模板列表
    getSchedulerList (queryType) {
      componentsAnalyze('scheduleTemplateListGetSchedulerList', '/ponent')
      if (!queryType) {
        this.STemplateListParam.pageNum = 1
      }
      if (this.STemplateListParam.condition) {
        const condition = this.STemplateListParam.condition
        this.STemplateListParam.condition = condition.replace(/(^\s*)|(\s*$)/g, '')
      }
      this.SchedulerTemplateLoading = true
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/template/listTemplate',
          this.STemplateListParam
        )
        .then((res) => {
          this.SchedulerTemplateLoading = false
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.STemplateHasnextpage = res.data.result.hasNextPage
              if (queryType) {
                this.SchedulerTemplateList.push(...res.data.result.list)
              } else {
                this.SchedulerTemplateList = res.data.result.list
              }
              Bus.$emit('leftListUpdate')
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(
          this.SchedulerTemplateLoading = false
        )
    }
  }
}
</script>

<style scoped lang="less">
.SchedulerTemplateList {
  height: 100%;
  .SchedulerTemplateTop {
    .searchTitle {
      padding: 12px 0 10px 0;
      border-bottom: 2px solid #555;
      text-align: right;
      i {
        margin: 0 4px;
        color: #cccccc;
      }
      .HaveLoop{
        color: #33AB4F;
      }
    }
    .searchInput {
      position: relative;
      ::v-deep .el-input__inner {
        padding-right: 45px;
      }
      i {
        position: absolute;
        right: 12px;
        font-size: 20px;
        top: 7px;
        z-index: 1001;
      }
    }
  }
  .STemplateListWrap {
    height: calc(100% - 50px);
    max-height: 529px;
    .STemplateItem {
      height: 100%;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      padding-top: 8px;
      margin: 0;
      .TemplateFile {
        // width: 336px;
        width: 100%;
        height: 28px;
        background: #444444;
        box-sizing: border-box;
        padding: 0 0 0 8px;
        font-size: 12px;
        color: #cccccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .templateName{
          width: 60%;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 28px;
        }
        .errTemplateName{
          color: #E56464;
        }
        .icon{
          width: 40%;
          display: none;
          text-align: right;
          i{
            font-size: 16px;
            margin-right: 6px;
          }
        }
      }
      .TemplateFile:hover .icon{
        display: block;
      }
      .pitchOnItem {
        background: #3f5d46;
      }
      .LoopTemplateName{
        color: #33AB4F;
      }
    }
  }
}
</style>
